export function escapeStatusMessageHtml(value) {
    return String(value ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

export function appendStaticStatusNote(message, staticStatusNote) {
    const baseMessage = String(message ?? "");
    const note = String(staticStatusNote ?? "").trim();
    if (!note) {
        return baseMessage;
    }

    const separator = baseMessage ? "<br/>" : "";
    return `${baseMessage}${separator}<b>備註：</b>${escapeStatusMessageHtml(note)}`;
}

export function combineStatusNotes(message, staticStatusNote) {
    const notes = [
        String(message ?? "").trim(),
        String(staticStatusNote ?? "").trim()
    ].filter(Boolean);

    return notes.join("\n");
}

export function prependStatusMessages(currentMessages, newMessages) {
    const current = Array.isArray(currentMessages) ? currentMessages : [];
    return [...newMessages, ...current];
}
